import React from 'react';

const RejectRecurringFileIcon = (): JSX.Element => (
  <svg
    fill="none"
    height="42"
    viewBox="0 0 43 42"
    width="43"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.7956 4.34945V31.145L21.0967 27.7956L14.3978 31.145L7.6989 27.7956L1 31.145V4.34945C1 3.46112 1.35289 2.60917 1.98103 1.98103C2.60917 1.35289 3.46112 1 4.34945 1H24.4461C25.3345 1 26.1864 1.35289 26.8146 1.98103C27.4427 2.60917 27.7956 3.46112 27.7956 4.34945Z"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66567"
    />
    <path d="M6 8H18" stroke="#EB5757" strokeLinecap="round" strokeWidth="2" />
    <path d="M6 15H22" stroke="#EB5757" strokeLinecap="round" strokeWidth="2" />
    <circle
      cx="31.4228"
      cy="30.2055"
      fill="#EB5757"
      r="10.4121"
      stroke="white"
      strokeWidth="1.67"
    />
    <path
      d="M36.1501 25.8655C36.1501 25.748 36.0568 25.6519 35.9429 25.6519L34.2335 25.6599L31.659 28.8239L29.0872 25.6625L27.3752 25.6545C27.2612 25.6545 27.168 25.748 27.168 25.8681C27.168 25.9189 27.1861 25.9669 27.2172 26.007L30.5868 30.1456L27.2172 34.2815C27.1859 34.3206 27.1685 34.3696 27.168 34.4203C27.168 34.5378 27.2612 34.634 27.3752 34.634L29.0872 34.6259L31.659 31.4619L34.2309 34.6233L35.9403 34.6313C36.0542 34.6313 36.1475 34.5378 36.1475 34.4177C36.1475 34.3669 36.1293 34.3189 36.0983 34.2788L32.7339 30.1429L36.1034 26.0043C36.1345 25.9669 36.1501 25.9162 36.1501 25.8655Z"
      fill="white"
    />
  </svg>
);

export default RejectRecurringFileIcon;
